import * as authentication from './authentication.js';

// Matches sanitizeUploadFilename in @repo/shared/helpers/uploadFilename.ts (9ID-1073)
function sanitizeUploadFilename(name) {
	return String(name || '').replace(/\u2013|\u2014/g, '-');
}

function extractUploadedForId() {

	if (typeof window === 'undefined') {
		return '';
	}
	if (!window.location.search.includes('userId=')) {
		return '';
	}

	const params = new URLSearchParams(window.location.search);
	return params.get('userId');
}

function extractUploadedForCompanyId() {

	if (typeof window === 'undefined') {
		return '';
	}
	// Because we recently switched from group to company we can have mixed use
	if (!window.location.search.includes('companyId=') && !window.location.search.includes('groupId=')) {
		return '';
	}

	const params = new URLSearchParams(window.location.search);
	const companyId = params.get('companyId') || params.get('groupId');
	// Filter out 'null' string and other falsy values
	return (companyId && companyId !== 'null') ? companyId : '';
}

export default function uploadFile(url, file, isPublic, {
	progressHandler = console.log,
	contentType,
	filename,
	type,
	uploadedForId,
	uploadedForCompanyId,
	metadata,
	context,
	allowedDocumentTypes,
}) {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.upload.onprogress = (e) => {
			if (e.lengthComputable) {
				progressHandler(100 * e.loaded / e.total);
			}
		};

		xhr.onerror = () => reject('Upload failed!');
		xhr.onload = () => {
			if (xhr.status > 300) {
				// todo, try to parse error message.
				return reject('Upload failed!');
			}

			const result = JSON.parse(xhr.responseText);
			return resolve(result);
		};

		const authParams = authentication.extractAuthParams();
		xhr.open('post', `${url}?${authParams}&isPublic=${isPublic}`);
		xhr.setRequestHeader('content-type', contentType);
		xhr.setRequestHeader('filename', sanitizeUploadFilename(filename));
		xhr.setRequestHeader('type', type || 'generic');
		if (context) {
			xhr.setRequestHeader('x-context', encodeURIComponent(JSON.stringify(context)));
		}
		const authHeader = authentication.extractAuthorization();
		uploadedForId = uploadedForId || extractUploadedForId();
		uploadedForCompanyId = uploadedForCompanyId || extractUploadedForCompanyId();
		if (authHeader) {
			xhr.setRequestHeader('Authorization', authHeader);
		}

		if (uploadedForId) {
			xhr.setRequestHeader('x-uploaded-for', uploadedForId);
		}

		if (uploadedForCompanyId) {
			xhr.setRequestHeader('x-uploaded-for-company', uploadedForCompanyId);
		}

		if (metadata) {
			xhr.setRequestHeader('x-metadata', JSON.stringify(metadata));
		}

		if (allowedDocumentTypes && Array.isArray(allowedDocumentTypes)) {
			xhr.setRequestHeader('x-allowed-document-types', JSON.stringify(allowedDocumentTypes));
		}

		xhr.send(file);
	});
}
